import { jsToRSQL, mergeRsqlFilters } from '@helpers'
import { GETDropDownFilter } from '@types'

export const prepareDropdownFilter = (
  generalFilterField: string,
  specificFilters?: GETDropDownFilter[] | null
) => {
  return mergeRsqlFilters(
    jsToRSQL(generalFilterField),
    ...(specificFilters?.map(filter => jsToRSQL(filter.value)) ?? [])
  )
}
